import styles from "./Card.module.scss";

interface Props {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

export const Card = (props: Props) => {
  const { className, children, onClick } = props;

  const { cardContainer } = styles;

  return (
    <div className={`${cardContainer} ${className ?? ""}`} onClick={onClick}>
      {children}
    </div>
  );
};
